import React, { useContext, useEffect, useRef, useState } from "react";
import AccountNavBar from "../../NewComponents/AccountNavBar";

import { ReactComponent as SEARCHICON } from "../../assets/icons/search.svg";
import DateFilter from "./OrdersComponents/DateFilter";
import { ReactComponent as DOWN } from "../../assets/icons/filter-down.svg";
import { ReactComponent as UP } from "../../assets/icons/filter-up.svg";
import { ReactComponent as SORTBLACK } from "../../assets/icons/sort-black.svg";
import { ReactComponent as DOWNLOAD } from "../../assets/icons/Download.svg";
import { ReactComponent as DATE } from "../../assets/icons/Date.svg";
import { useScreenTransition } from "../../Hooks/useScreenTransition";
import { TransitionContext } from "../../Context/TransitionContext";
import { DataContext } from "../../Context/DataContext";
import NoData from "../../NewComponents/NoData";
import { ReactComponent as MORE } from "../../assets/icons/More.svg";
import { ReactComponent as MORESELECTED } from "../../assets/icons/More-selected.svg";
import { ReactComponent as SORT_ASC } from "../../assets/icons/sort-asc.svg";
import { ReactComponent as SORT_DSC } from "../../assets/icons/sort-dsc.svg";
import { ReactComponent as STATUS } from "../../assets/icons/Status.svg";
import SearchFilter from "./OrdersComponents/SearchFilter";
import SendPaymentLinkPopUp from "../../NewComponents/SendPaymentLinkPopUp";
import { INVOICESTATUS } from "../../Data/statuses";
import { formatTotal } from "../../Data/Functions";
import { Configure, Pagination, SearchBox, useHits, useInstantSearch, useSearchBox, useSortBy } from "react-instantsearch-hooks-web";
import OpenInvoiceModal from "../../NewComponents/OpenInvoiceModal";
import { checkFetchAlgoliaData, firestore } from "../../firebase.config";
import { ReactComponent as Trash } from "../../assets/icons/Trash.svg";
import Clientsfilter from "./OrdersComponents/Clientsfilter";
import { ReactComponent as PLACEDBY } from "../../assets/icons/placed-by.svg";
import { Link } from "react-router-dom";
import QueryFilters from "./OrdersComponents/QueryFilters";



export const sampleInvoicesData = [
  {
  sample: true,
  objectID: "1234567890",
  id: "1234567890",
  email: "kathryn@murphy .com",
  clientFirstName: "Juan",
  clientLastName: "Alvarado",
  firstName: "Kathryn",
  lastName: "Murphy ",
  name: "Kathryn Murphy ",
  invoiceNumber: 15095,
  orders: [
    {
      id: "1234567890",
      number: 95095,
    }
  ],
  paymentId: "paid",
  status: "paid",
  teamId: "1234567890",
  teamName: "Sample Team",
  timestamp: 1755902188277,
  totalPrice: 24.94,
  type: "singleInvoice",
  userID: "1234567890",
},
  {
  sample: true,
  objectID: "1234567891",
  id: "1234567891",
  email: "darlene@robertson.com",
  clientFirstName: "Felix",
  clientLastName: "Goncalves",
  firstName: "Darlene",
  lastName: "Robertson",
  name: "Darlene Robertson",
  invoiceNumber: 15096,
  orders: [
    {
      id: "1234567891",
      number: 95096,
    }
  ],
  paymentId: "paid",
  status: "paid",
  teamId: "1234567890",
  teamName: "Sample Team",
  timestamp: 1755902188277,
  totalPrice: 64.84,
  type: "singleInvoice",
  userID: "1234567890",
},
  {
  sample: true,
  objectID: "1234567892",
  id: "1234567892",
  email: "cameronus@williamson.com",
  clientFirstName: "Amelia",
  clientLastName: "Hoxha",
  firstName: "Cameronus",
  lastName: "Williamson",
  name: "Cameronus Williamson",
  invoiceNumber: 15097,
  orders: [
    {
      id: "1234567892",
      number: 95097,
    }
  ],
  paymentId: "paid",
  status: "paid",
  teamId: "1234567890",
  teamName: "Sample Team",
  timestamp: 1755902188277,
  totalPrice: 89.78,
  type: "singleInvoice",
  userID: "1234567890",
},
]


const AccountInvoicesComponent = ({windowSize}) => {

    const { transitionTo } = useScreenTransition();

    const { setColor } = useContext(TransitionContext);
    const { userData, teamData } = useContext(DataContext);
  
  
    const [showFilter, setShowFilter] = useState("");
  
    const [filterStartTimestamp, setFilterStartTimestamp] = useState(null);
    const [filterEndTimestamp, setFilterEndTimestamp] = useState(null);
    const [datePeriod, setDatePeriod] = useState("custom");

    const [paymentFilter, setPaymentFilter] = useState("");
    const [moreOptions, setMoreOptions] = useState("");
    const [selectedSendPayment, setSelectedSendPayment] = useState("");
    const [openInvoiceModal, setOpenInvoiceModal] = useState();
    const [teamMembers, setTeamMembers] = useState([]);
    const [selectedMembers, setSelectedMembers] = useState([]);
    
    const moreOptionsRef = useRef(null);
    let nextPointer = useRef();
    if (!nextPointer.current) nextPointer.current = null;

    const handleDownloadInvoice = (invoice) => {
      setMoreOptions("");
      setOpenInvoiceModal(invoice);
    }

    useEffect(() => {
        setColor(true);
      }, [setColor]);

        const [localInvoices, setLocalInvoices] = useState([]);
  
    useEffect(()=> {
      if(!checkFetchAlgoliaData()){
        if( userData.id){
          firestore.collection("orderInvoices").where(userData.teamId ? "teamId" : "userID", "==", userData.teamId ?? userData.id).orderBy("timestamp", "desc").get()
          .then(qSnap => {
            if(qSnap.empty){
              return;
            }
  
            setLocalInvoices(qSnap.docs.map(doc => ({...doc.data(), objectID: doc.id})));
          })
        }
      }
  
    }, 
    [userData,teamData])


     useEffect(() => {
       const handleClickOutside = (event) => {
         if (!event.target.closest('.hardCopyAddressIconWrap')) {
           setMoreOptions("");
         }
       };
       document.addEventListener("mousedown", handleClickOutside);
       return () => {
         document.removeEventListener("mousedown", handleClickOutside);
       };
     }, []);

    const checkAnyFilterSelected = () => {
        if(filterStartTimestamp){
          return true;
        }
        if(filterEndTimestamp){
          return true;
        }
         if (selectedMembers.length > 0) {
          return true;
        }
        if(paymentFilter !== ""){
          return true;
        }
        return false
    }

    const formatFilterDate = (date) => {
        return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    };
      
    const getSelectedDateText = () => {
        if(filterStartTimestamp){
            if(filterEndTimestamp){
            return formatFilterDate(new Date(filterStartTimestamp)) +  " - "
                + formatFilterDate(new Date(filterEndTimestamp));
            }else{
            return formatFilterDate(new Date(filterStartTimestamp)) +  " - "
                + formatFilterDate(new Date());
            }

        }else{
            return "Date";
        }
    }

    const formatDate = (timestamp, showTime = false) => {
        const date = new Date(timestamp);
    
        const splitted = date.toDateString().split(" ");
    
        const time = showTime ? (' @ ' + date.toTimeString().substr(0, 5)) : "";
    
        return (
          splitted[1] +
          " " +
          splitted[2] +
          ", " +
          splitted[3] + time
        );
      };  

    const {hits} = useHits();
    const {status} = useInstantSearch();
    const {query} = useSearchBox();
    const [loading, setLoading] = useState(true);

    const items = [
      {
      Label: "Default",
      value: "orderInvoices"
      },
      {
      Label: "Date asc",
      value: "invoice_time_asc"
      },
      {
      Label: "Date dsc",
      value: "invoice_time_dsc"
      },
      {
      Label: "Status asc",
      value: "invoice_status_asc"
      },
      {
      Label: "Status dsc",
      value: "invoice_status_dsc"
      },
    ]
    const { currentRefinement, refine } = useSortBy({items: items, defaultRefinement: "invoice_time_dsc"});

    useEffect(() => {
      if(status === "loading" || status === "stalled"){
        setLoading(true);
      }else{
        setLoading(false);
      }
    }, [status])

    useEffect(() => {
      if(currentRefinement === "orderInvoices"){
        refine("invoice_time_dsc");
      }
    }, [currentRefinement])
 

  const [filters, setFilters] = useState(`userID: ${userData ? userData.id : "no-user"}`);
  
  useEffect(() => {
    const defalutFilters = userData && userData.teamId ? `teamId: ${userData.teamId}`: `userID: ${userData ? userData.id : "no-user"}`;
    let tempFilters = defalutFilters;
    
    if(filterStartTimestamp && filterEndTimestamp){
      tempFilters += ` AND timestamp >= ${filterStartTimestamp} AND timestamp <= ${filterEndTimestamp}`
    }
    if(paymentFilter){
      tempFilters += ` AND status:${paymentFilter}`;
    }
    if(selectedMembers.length > 0){
      selectedMembers.forEach((email, i) => {tempFilters +=` ${i === 0 ? "AND" : "OR"} email:${email}`});
    }

    if(userData && (tempFilters === `teamId: ${userData.teamId}` || tempFilters === `userID: ${userData ? userData.id : "no-user"}`) && query === ""){
      if(!checkFetchAlgoliaData() ? localInvoices.length === 0 : hits.length === 0){
        setShowSampleInvoices(true);
      }else{
        setShowSampleInvoices(false);
      }
    }else{
      setShowSampleInvoices(false);
    }


    setFilters(tempFilters);
  }
  , [paymentFilter, filterStartTimestamp, filterEndTimestamp, userData,selectedMembers])

  const handleMoreOptions = (e, id) => {
    e.stopPropagation();
    moreOptions=== id ? setMoreOptions("") : setMoreOptions(id)
  }

  const [showSampleInvoices, setShowSampleInvoices] = useState(true);
    
    
  const [sampleInvoices, setSampleInvoices] = useState(null);
  useEffect(() => {
    if(hits.length === 0){
      const sampleInvoices = JSON.parse(localStorage.getItem("sampleInvoices"));
      if(!sampleInvoices){
        localStorage.setItem("sampleInvoices", JSON.stringify(sampleInvoicesData));
      }
      setSampleInvoices(sampleInvoices);
    }
  }, [hits]);

  const onClickSampleDelete = (invoice)=> {
    const i = sampleInvoices.filter(i => i.objectID !== invoice.objectID);
    localStorage.setItem("sampleInvoices", JSON.stringify(i));
    setSampleInvoices(i);
  }

  const TableDataComponent = ({hits}) => {

    // if(hits.length === 0){
    //   return <tbody></tbody>;
    // }

    const invoices = hits.length === 0 && showSampleInvoices ? sampleInvoices || [] : hits;

    return (
      <tbody>
      {invoices.map(hit =>
      {
        const invoice = {...hit, id: hit.objectID}
        return (
        <tr key={invoice.id} onClick={(e) => transitionTo(`/account/invoice/${invoice.id}`, e)}>
          {invoice.sample ? <td className="quotewidth accountDetailsLink text-[#9A9FA7]">Sample</td> : ""}
          <td>
            <Link to={`/account/invoice/${invoice.id}`} onClick={(e) => e.stopPropagation()}>
              <p
                className="accountDetailsText accountDetailsLink"
              >
                {invoice.invoiceNumber}
              </p>
            </Link>
          </td>
          <td>
            <Link to={`/account/invoice/${invoice.id}`} onClick={(e) => e.stopPropagation()}>
              <p className="accountDetailsText">
                {invoice.billingPeriod ? invoice.billingPeriod : formatDate(invoice.timestamp)}
              </p>
            </Link>
          </td>
          <td>
            <Link to={`/account/invoice/${invoice.id}`} onClick={(e) => e.stopPropagation()}>
              <p
                className="quotewidth  accountDetailsStatus"
                style={{
                  backgroundColor: INVOICESTATUS[invoice.status]
                    ? INVOICESTATUS[invoice.status][1]
                    : "",
                }}
              >
                {INVOICESTATUS[invoice.status]
                  ? INVOICESTATUS[invoice.status][0]
                  : invoice.status}
              </p>
            </Link>
          </td>
          <td>
            <Link to={`/account/invoice/${invoice.id}`} onClick={(e) => e.stopPropagation()}>
              <p className="accountDetailsText accountDetailsLink">
              {invoice.sample ? "#"+invoice.orders[0].number : invoice.teamId ? invoice.orders && invoice.orders.length > 1 ? invoice.orders.length : "#"+invoice.orders[0].number
                : "#"+invoice.orders[0].number}
              </p>
            </Link>
          </td>
          {userData && userData.teamId &&
          <td>
            <Link to={`/account/invoice/${invoice.id}`} onClick={(e) => e.stopPropagation()}>
              <p className="accountDetailsText accountDetailsLink">
              {invoice.orders.length === 1 ? invoice.name : "-"}
              </p>
            </Link>
          </td>}
          {userData && userData.teamId && 
          <td>
            <Link to={`/account/invoice/${invoice.id}`} onClick={(e) => e.stopPropagation()}>
              <p className="accountDetailsText accountDetailsLink">
              {invoice.clientFirstName ? invoice.clientFirstName + " " + (invoice.clientLastName || "") : "-"}
              </p>
            </Link>
          </td>}
          <td>
            <Link to={`/account/invoice/${invoice.id}`} onClick={(e) => e.stopPropagation()}>
              <p className="accountDetailsText">
                {formatTotal(invoice.totalPrice)}
              </p>
            </Link>
          </td>
          {userData && (
            <td className="flex justify-center">
              <p
              
                style={{ width: "100%", textAlign: "center" }}
                className="accountDetailsText"
              >
              {invoice.teamId && ((invoice.status === "pay-later" && invoice.type === "singleInvoice") || invoice.status === "overdue") ?
                <button className="accountOrderBtn" onClick={(e) => {e.stopPropagation(); transitionTo(`/make-payment/invoice/${invoice.id}`, e)}} >Pay</button> : INVOICESTATUS[invoice.status] ? INVOICESTATUS[invoice.status][0]: "paid"
              }
              </p>
            </td>
          )}
          <td onClick={(e) => e.stopPropagation()}>
          {invoice.teamId && ((invoice.status === "pay-later" && invoice.type === "singleInvoice") || invoice.status === "overdue") ?
          <div className="hardCopyAddressIconWrap" ref={moreOptionsRef}>
              {moreOptions === invoice.id ? <MORESELECTED className="hardCopyAddressIcon" onClick={(e) => {e.stopPropagation(); setMoreOptions("")}}/> :
              <MORE className="hardCopyAddressIcon" onClick={(e) => {e.stopPropagation(); setMoreOptions(invoice.id)}}/>}
        
              {moreOptions === invoice.id && <div className="hardCopyAddressEditWrap">
              <div className="hardCopyAddressEdit" onClick={() => handleDownloadInvoice(invoice)}>View Invoice</div>
              {<div className="hardCopyAddressEdit" onClick={() => {setSelectedSendPayment(invoice); setMoreOptions("")}}>Send Payment Link</div>}
              </div>}
          </div>
          :invoice.sample ? <Trash onClick={() => onClickSampleDelete(invoice)}/> : 
          <DOWNLOAD className="hardCopyAddressIcon" onClick={() => handleDownloadInvoice(invoice)}/>
          }
          </td>
        </tr>)
      })}
    </tbody>
    )
  }

   useEffect(() => {
      if (userData && userData.teamId) {
  
  
        firestore
          .collection("users")
          .where("teamId", "==", userData.teamId).orderBy("name", "asc")
          .get()
          .then((qSnap) => {
            if (!qSnap.empty) {
              setTeamMembers(
                qSnap.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
              );
            }
          });
      }
    }, [ userData]);

  return (
    <>
    <Configure filters={filters} hitsPerPage={20}/>

    <QueryFilters
        setFilterStartTimestamp={setFilterStartTimestamp}
        filterStartTimestamp={filterStartTimestamp}
        setFilterEndTimestamp={setFilterEndTimestamp}
        filterEndTimestamp={filterEndTimestamp}
        setDatePeriod={setDatePeriod}
        datePeriod={datePeriod}
        setStatusFilter={setPaymentFilter}
        statusFilter={paymentFilter}
        setSelectedMembers={setSelectedMembers}
        selectedMembers={selectedMembers}
        baseUrl="/account/invoices"
      />

    {openInvoiceModal && <OpenInvoiceModal type="invoice" order={openInvoiceModal} onClose={() => setOpenInvoiceModal(null)}/>}
    

      {selectedSendPayment !== "" && (
        <SendPaymentLinkPopUp
          data={selectedSendPayment}
          type={"invoice"} 
          id={selectedSendPayment.id}
          onClose={() => setSelectedSendPayment("")}
        />
      )}

       <AccountNavBar
        windowSize={windowSize}
        selectedTab="invoices"
        accountMainPadding={false}
      >
        <div className="accountMainTitleRow px-5 pt-5">
          <h2 className="accountMainTitle">Invoices</h2>
          
          <SearchBox classNames={{
            root: "newSearchbox",
            form: "newSearchbox_form",
            input: "newSearchbox_input",
            reset: "hidden",
            loadingIndicator: "hidden",
          }} 
          placeholder="Search By ID or Client or Placed By" 
          submitIconComponent={() => <SEARCHICON/>} />
        </div>

        <div className="accountDetailsFiltersWrap m-0 px-4 w-full">
          <div className="relative sm:w-fit w-full">
            <div
              className="accountDetailsFilter"
              style={{
                borderColor:
                  showFilter === "date" ||
                    filterStartTimestamp ||
                    filterEndTimestamp
                    ? "#12ABBF"
                    : "#E6E7E9",
              }}
              onClick={(e) => {
                setShowFilter((f) => (f === "date" ? "" : "date"));
              }}
            >
              <DATE />
              <p className="accountDetailsFilterText">
                {getSelectedDateText()}
              </p>
              {showFilter === "date" ? <UP /> : <DOWN />}
            </div>
            {showFilter === "date" && (
              <DateFilter
                setShowModal={setShowFilter}
                startTimestamp={filterStartTimestamp}
                setStartTimestamp={setFilterStartTimestamp}
                endTimestamp={filterEndTimestamp}
                setEndTimestamp={setFilterEndTimestamp}
                period={datePeriod}
                setPeriod={setDatePeriod}
                onMouseLeave={() => setShowFilter("")}
              />
            )}
          </div>

          <div style={{position: "relative"}}>
            <div className="accountDetailsFilter" style={{borderColor: (showFilter === "payment" || paymentFilter.length > 0) ? "#12ABBF" : "#E6E7E9"}} onClick={(e) => {setShowFilter(f => f === "payment" ? "" : "payment")}}>
              <STATUS/>
              <p className="accountDetailsFilterText">Status {paymentFilter !== "" ? ` (${paymentFilter})` : "" }</p>
              {showFilter === "payment" ? <UP/> : <DOWN/>}
            </div>
            {showFilter === "payment" && <SearchFilter type="payment" setStatusFilter={setPaymentFilter} selectedFilters={paymentFilter} setShowModal={setShowFilter}/>}
          </div>

           {teamData && teamMembers.length > 0 && (
              <div className="relative">
              <div
                  className="accountDetailsFilter"
                  style={{
                  borderColor:
                      showFilter === "placedBy" || selectedMembers.length > 0
                      ? "#12ABBF"
                      : "#E6E7E9",
                  }}
                  onClick={(e) => {
                  setShowFilter((f) => (f === "placedBy" ? "" : "placedBy"));
                  }}
              >
                  <PLACEDBY />
                  <p className="accountDetailsFilterText">
                  Placed By{" "}
                  {selectedMembers.length > 0
                      ? ` (${selectedMembers.length}) `
                      : ""}
                  </p>
                  {showFilter === "placedBy" ? <UP /> : <DOWN />}
              </div>
              {showFilter === "placedBy" && (
                  <Clientsfilter
                  setShowModal={setShowFilter}
                  clients={teamMembers}
                  setSelectedClients={setSelectedMembers}
                  selectedClients={selectedMembers}
                  />
              )}
              </div>
          )}
        </div>

        <div className="accountDetailsScroll w-full">
          {loading ? <NoData loadingText={"invoices"} loading={true} showBtn={false} type="order"/> :
          (!checkFetchAlgoliaData() ? localInvoices.length === 0 : hits.length === 0) && (!showSampleInvoices || (sampleInvoices && sampleInvoices.length === 0)) &&
          <NoData
            type="order"
            text={checkAnyFilterSelected() || query !== "" ? "Please select another filter" : ""}
            title={checkAnyFilterSelected() || query !== "" ? "No Invoice Matching This Filter": "You Don't Have Any Active Invoice Yet"}
            showBtn={false}
          /> }
          {((!checkFetchAlgoliaData() ? localInvoices.length > 0 : hits.length > 0) || (sampleInvoices && sampleInvoices.length > 0)) && !loading &&
          <table className="accountDetailsTable" style={{display: loading ? "none" : "table"}}>
            <thead>
                  <tr>
                    {showSampleInvoices && (!checkFetchAlgoliaData() ? localInvoices.length === 0 : hits.length === 0) ? <th></th> : ""}
                    <th>
                      <p className="accountDetailsHeading">ID</p>
                    </th>
                    <th>
                      <div className="accountData">
                        <p className="accountDetailsHeading">Date</p>
                        { currentRefinement === "invoice_time_dsc" ? 
                        <SORT_DSC className="sortIcon" onClick={() => refine("invoice_time_asc")}/> 
                        : currentRefinement === "invoice_time_asc" ?
                        <SORT_ASC className="sortIcon" onClick={() => refine("invoice_time_dsc")}/> 
                        : <SORTBLACK className="sortIcon" onClick={() => refine("invoice_time_dsc")}/>
                        }
                      </div>
                    </th>
                    <th>
                      <div className="accountData">
                        <p className="accountDetailsHeading">Status</p>
                        { currentRefinement === "invoice_status_dsc" ? 
                        <SORT_DSC className="sortIcon" onClick={() => refine("invoice_status_asc")}/> 
                        : currentRefinement === "invoice_status_asc" ?
                        <SORT_ASC className="sortIcon" onClick={() => refine("invoice_status_dsc")}/> 
                        : <SORTBLACK className="sortIcon" onClick={() => refine("invoice_status_dsc")}/>
                        }
                      </div>
                    </th>
                    <th>
                      <div className="accountData">
                        <p className="accountDetailsHeading">{showSampleInvoices  && (!checkFetchAlgoliaData() ? localInvoices.length === 0 : hits.length === 0) ? "Order ID" : (userData && userData.teamId ? "Orders" :"Order ID")}</p>
                      </div>
                    </th>
                    {userData && userData.teamId && (
                      <th>
                          <div className="accountData">
                          <p className="accountDetailsHeading">Placed By</p>
                          { currentRefinement === "invoice_name_dsc" ? 
                          <SORT_DSC className="sortIcon" onClick={() => refine("invoice_name_asc")}/> 
                          : currentRefinement === "invoice_name_asc" ?
                          <SORT_ASC className="sortIcon" onClick={() => refine("invoice_name_dsc")}/> 
                          : <SORTBLACK className="sortIcon" onClick={() => refine("invoice_name_asc")}/>
                          }
                          </div>
                      </th>
                      )}
                      {userData && userData.teamId && (
                      <th>
                      <div className="accountData">
                          <p className="accountDetailsHeading">Client</p>
                          { currentRefinement === "invoice_client_dsc" ? 
                          <SORT_DSC className="sortIcon" onClick={() => refine("invoice_client_asc")}/> 
                          : currentRefinement === "invoice_client_asc" ?
                          <SORT_ASC className="sortIcon" onClick={() => refine("invoice_client_dsc")}/> 
                          : <SORTBLACK className="sortIcon" onClick={() => refine("invoice_client_asc")}/>
                          }
                      </div>
                      </th>
                      )}
                    <th>
                      <div className="accountData">
                        <p className="accountDetailsHeading">Total</p>
                        {/* { selectedSort === "total" ? 
                          <SORT className="sortIcon" onClick={() => refine("total")}/> 
                          : <SORTBLACK className="sortIcon" onClick={() => refine("total")}/>
                          } */}
                      </div>
                    </th>
                    {userData && (
                      <th>
                        <div className="accountData " style={{ justifyContent: "center"}}>
                          <p className="accountDetailsHeading">Payment</p>
                          {/* { currentRefinement === "orderInvoices" ? 
                            <SORT_DSC className="sortIcon" onClick={() => handleSort("invoice_time_asc")}/> 
                            : currentRefinement === "invoice_time_asc" ?
                            <SORT_ASC className="sortIcon" onClick={() => handleSort("orderInvoices")}/> 
                            : <SORTBLACK className="sortIcon" onClick={() => handleSort("orderInvoices")}/>
                        } */}
                        </div>
                      </th>
                    )}
                    <th></th>
                  </tr>
                </thead>

                <TableDataComponent hits={!checkFetchAlgoliaData() ? localInvoices : hits}/>

            </table>}
                {hits.length > 0 && 
                <Pagination
                padding={0}
                showFirst={false}
                showPrevious={true}
                showNext={true}
                showLast={false}
                classNames={{
                  root: "w-full my-4 mx-2",
                  list: "w-full flex justify-center items-center gap-2",
                  item: "",
                  selectedItem:"",
                  disabledItem:"opacity-50 cursor-not-allowed",
                  previousPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
                  nextPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
                  firstPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
                  lastPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
                }}
                translations={{
                previousPageItemText: 'Previous',
                nextPageItemText: 'Next',
                pageItemText: ({ currentPage, nbPages }) => `Page ${currentPage}`,
                previousPageItemAriaLabel: 'Go to previous page',
                nextPageItemAriaLabel: 'Go to next page',
                pageItemAriaLabel: ({ currentPage, nbPages }) => `Go to page ${currentPage} of ${nbPages}`,
              }}
                />}
        </div>
        
    </AccountNavBar>

    </>
  );
};

export default AccountInvoicesComponent;
